export interface WizardSuccessBannerProps {
  memberName: string;
  onReturnHome: () => void;
}

export function WizardSuccessBanner({ memberName, onReturnHome }: WizardSuccessBannerProps) {
  const handleReturnHome = () => {
    onReturnHome();
    window.location.hash = '/features';
  };

  return (
    <div>
      <h3 style={{ marginBottom: 4 }}>
        <strong>Home Delivery Enrollment</strong>
      </h3>
      {memberName && <p style={{ marginBottom: 20, color: '#495057' }}>{memberName}</p>}

      {/* Success banner */}
      <div
        style={{
          backgroundColor: '#198754',
          borderRadius: '8px 8px 0 0',
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
          aria-hidden="true"
        >
          <span style={{ color: 'white', fontWeight: 'bold', fontSize: 18 }}>&#10003;</span>
        </div>
        <div>
          <p style={{ color: 'white', fontWeight: 700, margin: 0, fontSize: '1.05rem' }}>
            Home Delivery Enrollment Submitted
          </p>
          <p style={{ color: 'rgba(255, 255, 255, 0.9)', margin: 0, fontSize: '0.9rem' }}>
            Your request has been received.
          </p>
        </div>
      </div>

      {/* Body */}
      <div
        style={{
          border: '1px solid #dee2e6',
          borderTop: 'none',
          borderRadius: '0 0 8px 8px',
          padding: '24px 20px',
        }}
      >
        <p style={{ fontWeight: 700, marginBottom: 8 }}>What happens next?</p>
        <p className="text-muted" style={{ marginBottom: 20 }}>
          Your Home Delivery enrollment request has been submitted. Our team will review and
          process your request within the next two business days.
        </p>

        <div
          style={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffc107',
            borderRadius: 8,
            padding: '12px 16px',
            marginBottom: 20,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 10,
          }}
        >
          <span style={{ fontSize: 20, lineHeight: 1.2 }} aria-hidden="true">
            &#9888;
          </span>
          <p style={{ margin: 0, color: '#664d03' }}>
            Please allow up to two business days for your account setup to be completed. During
            this time, Home Delivery prescription management will not yet be available.
          </p>
        </div>

        <p className="text-muted" style={{ marginBottom: 24 }}>
          Check back soon &mdash; once processing is complete, you&rsquo;ll have full access to
          manage your Home Delivery prescriptions here.
        </p>

        <button type="button" className="btn btn-primary" onClick={handleReturnHome}>
          Back to Member Features
        </button>
      </div>
    </div>
  );
}
